import { HbNotificationAction } from './notification-action';
import { NotificationLife } from './notification-life';
import { NotificationState } from './notification-state';

export class HbNotification {
  id: string;
  notificationType: string;
  state: NotificationState;
  description: string;
  message: string;
  actions = new Array<HbNotificationAction>();
  life: NotificationLife = NotificationLife.Common;
  closable: boolean = false;
}
